import styled from 'styled-components';
import { Grid, Chip, Card, Divider } from '@mui/material';
import Typography from '@atoms/Typography';
import { devices, deviceSizes } from 'config/devices';
import Avatar from '@atoms/Avatar';
export var OpportunityMeta = styled(Typography).withConfig({
  displayName: "style__OpportunityMeta",
  componentId: "sc-1w8e3a8-0"
})(["display:flex;align-items:center;width:100%;&&{margin-bottom:0.5rem;margin-top:0.5rem;color:", ";}svg{margin-right:25px;width:1.2rem;height:1.2rem;}", ""], function (_ref) {
  var primary = _ref.primary,
    theme = _ref.theme;
  return primary ? theme.red[900] : theme.secondaryColor[700];
}, function (_ref2) {
  var maxLines = _ref2.maxLines;
  return maxLines && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -moz-box-orient: vertical;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ".concat(maxLines, ";\n    \n    ");
});
export var ShareBox = styled.div.withConfig({
  displayName: "style__ShareBox",
  componentId: "sc-1w8e3a8-1"
})(["display:flex;margin-top:20px;width:50%;justify-content:space-between;align-items:center;@media (max-width:", "){width:95%;}"], deviceSizes.sm);
export var DedaLine = styled(Typography).withConfig({
  displayName: "style__DedaLine",
  componentId: "sc-1w8e3a8-2"
})(["display:flex;align-items:center;width:100%;&&{margin-bottom:50px;margin-top:0.5rem;color:", " !important;}svg{margin-right:25px;width:1.2rem;height:1.2rem;}", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.red[900];
}, function (_ref4) {
  var maxLines = _ref4.maxLines;
  return maxLines && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -moz-box-orient: vertical;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ".concat(maxLines, ";\n    \n    ");
});
export var ActionsContainer = styled(Grid).withConfig({
  displayName: "style__ActionsContainer",
  componentId: "sc-1w8e3a8-3"
})(["flex-direction:row;display:flex;align-items:center;&&{padding:1rem 0;hr{display:flex;flex-grow:2;}}"]);
export var BodyContainer = styled(Card).withConfig({
  displayName: "style__BodyContainer",
  componentId: "sc-1w8e3a8-4"
})(["margin-top:1rem;padding:3.6875rem 4.625rem;@media ", "{margin-top:8rem;}@media ", "{padding:1rem 1.5rem;}&&{border-radius:16px;width:720px;}"], devices.sm, devices.xs);
export var SectionDivider = styled(Divider).withConfig({
  displayName: "style__SectionDivider",
  componentId: "sc-1w8e3a8-5"
})(["&&{margin-top:1.5rem;margin-bottom:1.5rem;width:100%;}"]);
export var ChipsContainer = styled.div.withConfig({
  displayName: "style__ChipsContainer",
  componentId: "sc-1w8e3a8-6"
})(["display:flex;align-items:flex-end;flex-wrap:wrap;.MuiChip-root{margin-right:0.5rem;margin-bottom:0.5rem;}"]);
export var BodyText = styled.div.withConfig({
  displayName: "style__BodyText",
  componentId: "sc-1w8e3a8-7"
})(["margin:0.5rem 4rem;.MuiTypography-body1{color:", ";}pre{color:", ";}h6{color:", ";}@media (max-width:", "){margin:0.5rem 2rem}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.secondaryColor[700];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.secondaryColor[700];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.secondaryColor[600];
}, deviceSizes.sm);
export var OrgAvatar = styled(Avatar).withConfig({
  displayName: "style__OrgAvatar",
  componentId: "sc-1w8e3a8-8"
})(["border:2px solid ", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.primary.main;
});
export var LogoContainer = styled.div.withConfig({
  displayName: "style__LogoContainer",
  componentId: "sc-1w8e3a8-9"
})(["display:flex;justify-content:flex-start;align-items:center;position:relative;margin-bottom:1rem;.MuiAvatar-root{width:64px;height:64px;margin-right:20px;}.MuiBox-root{width:36px;height:36px;position:absolute;left:-15px;bottom:2px;background-color:", ";border-radius:50%;display:flex;justify-content:center;align-items:center;color:white;font-size:10px;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.primary.main;
});
export var StyledChip = styled(Chip).withConfig({
  displayName: "style__StyledChip",
  componentId: "sc-1w8e3a8-10"
})(["&&{background-color:", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.secondaryColor[50];
});